import { render, staticRenderFns } from "./storage-management.vue?vue&type=template&id=3f6b439a&"
import script from "./storage-management.vue?vue&type=script&lang=js&"
export * from "./storage-management.vue?vue&type=script&lang=js&"
import style0 from "./storage-management.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports